var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17278_104178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.28087 12.9182C8.20647 12.6298 8.05615 12.3666 7.84555 12.156C7.63495 11.9454 7.37176 11.7951 7.08336 11.7207L1.97086 10.4023C1.88364 10.3776 1.80687 10.3251 1.75221 10.2527C1.69754 10.1804 1.66797 10.0922 1.66797 10.0015C1.66797 9.91084 1.69754 9.82264 1.75221 9.7503C1.80687 9.67797 1.88364 9.62543 1.97086 9.60068L7.08336 8.28151C7.37166 8.20718 7.63477 8.05699 7.84537 7.84654C8.05596 7.6361 8.20634 7.37308 8.28087 7.08484L9.5992 1.97234C9.6237 1.88477 9.67618 1.80763 9.74863 1.75267C9.82108 1.69772 9.90952 1.66797 10.0004 1.66797C10.0914 1.66797 10.1798 1.69772 10.2523 1.75267C10.3247 1.80763 10.3772 1.88477 10.4017 1.97234L11.7192 7.08484C11.7936 7.37324 11.9439 7.63642 12.1545 7.84702C12.3651 8.05762 12.6283 8.20794 12.9167 8.28234L18.0292 9.59984C18.1171 9.62409 18.1946 9.67652 18.2499 9.74907C18.3052 9.82163 18.3351 9.91031 18.3351 10.0015C18.3351 10.0927 18.3052 10.1814 18.2499 10.2539C18.1946 10.3265 18.1171 10.3789 18.0292 10.4032L12.9167 11.7207C12.6283 11.7951 12.3651 11.9454 12.1545 12.156C11.9439 12.3666 11.7936 12.6298 11.7192 12.9182L10.4009 18.0307C10.3764 18.1182 10.3239 18.1954 10.2514 18.2503C10.179 18.3053 10.0905 18.3351 9.99962 18.3351C9.90868 18.3351 9.82025 18.3053 9.7478 18.2503C9.67535 18.1954 9.62287 18.1182 9.59836 18.0307L8.28087 12.9182Z",
    stroke: "#14904A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.666 2.5V5.83333",
    stroke: "#14904A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 4.16797H15",
    stroke: "#14904A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 14.168V15.8346",
    stroke: "#14904A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 15H2.5",
    stroke: "#14904A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17278_104178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchIcon);
export default __webpack_public_path__ + "static/media/switch-icon.5d63d0a7434b1bd9f9cf354e2a3d68e4.svg";
export { ForwardRef as ReactComponent };